import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useHistory } from 'react-router-dom'

import FormPage from '../resource/form.page'
import Api from '../../service/api'
import { OverlayLoader } from '../../components/loader'
import { CATEGORY } from '../../components/form/field/react-selects'
import { IconAddMember } from '../../components/icons'

export const Draft = () => {
	const [isLoading, setLoading] = useState(false)
	const [initFormData, setInitFormData] = useState({})
	const fields = React.useMemo(() => {
		const state = [
			{
				name: 'id',
				type: 'hidden',
				defaultValue: 'id',
			},
			{
				label: '[Text]',
				name: 'text',
				type: 'text',
				placeholder: '[Placeholder]'
			},
			{
				label: '[Text, inline]',
				name: 'text',
				type: 'text',
				inline: true,
				placeholder: '[Placeholder]'
			},
			{
				label: '[Text, readonly]',
				name: 'text',
				type: 'text',
				readOnly: 'true',
				placeholder: '[Placeholder]'
			},
			{
				label: '[Text, inline, readOnly]',
				name: 'text',
				type: 'text',
				inline: true,
				readOnly: 'true',
				placeholder: '[Placeholder]'
			},
			{
				label: '[Textarea]',
				name: 'textarea',
				type: 'textarea',
				placeholder: '[Placeholder]'
			},
			{
				label: '[Textarea, readonly]',
				name: 'textarea',
				type: 'textarea',
				readOnly: 'true',
				placeholder: '[Placeholder]'
			},
			{
				label: '[Textarea, inline]',
				name: 'textarea',
				type: 'textarea',
				inline: 'true',
				placeholder: '[Placeholder]'
			},
			{
				label: '[Textarea, inline, readOnly]',
				name: 'textarea',
				type: 'textarea',
				inline: 'true',
				readOnly: 'true',
				placeholder: '[Placeholder]'
			},
			// {
			// 	name: 'render',
			// 	type: 'render',
			// 	render: (item, props) => {
			// 		return <>
			// 			<div>Render</div>
			// 			<pre>{ JSON.stringify({item}) }</pre>
			// 			<pre>{ JSON.stringify({props}) }</pre>
			// 		</>
			// 	},
			// },
			{
				label: '[ReactSelect]',
				name: 'reactselect',
				type: 'reactselect',
				isClearable: true,
				isMulti: true,
				isSearchable: true,
				options: [
					{ label: 'A', value: 'a' },
					{ label: 'B', value: 'b' },
				],
				hint: '[Hint]'
			},
			{
				label: '[RadioBox]',
				name: 'radiobox',
				type: 'radiobox',
			},
			{
				label: '[CheckBox]',
				name: 'checkbox',
				type: 'checkbox',
			},
		]

		return state
	}, [])

	return <>
		<OverlayLoader show={isLoading}>
			<FormPage
				resource='user'
				action={'add'}
				fields={fields}
				initialValues={initFormData}
			/>
		</OverlayLoader>
	</>
}
export default Draft
